<template>
  <div class="development-history">
    <!-- Banner 图片 -->
    <div v-if="data.bannerImage" class="banner-section">
      <img :src="data.bannerImage" alt="Banner" class="banner-image">
    </div>

    <!-- 时间线列表 -->
    <div v-if="data.list && data.list.length > 0" class="timeline-section">
      <div class="timeline-container">
        <div
          v-for="(item, index) in sortedList"
          :key="index"
          class="timeline-item"
          :class="{ 'timeline-item-alt': index % 2 === 1 }"
        >
          <div class="timeline-date">{{ item.date }}</div>
          <div class="timeline-description">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DevelopmentHistory',
  props: {
    data: {
      type: Object,
      default: () => ({
        bannerImage: '',
        list: []
      })
    }
  },
  computed: {
    // 按时间倒序排列（最新的在上）
    sortedList () {
      if (!this.data.list || this.data.list.length === 0) {
        return []
      }
      // 复制数组并倒序排列
      return [...this.data.list].reverse()
    }
  }
}
</script>

<style scoped>
.development-history {
  width: 100%;
}

/* Banner 区域 */
.banner-section {
  width: 100%;
  height: 400px;
  margin-bottom: 40px;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 时间线区域 */
.timeline-section {
  width: 100%;
  padding: 40px 0;
}

.timeline-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.timeline-item {
  display: flex;
  align-items: center;
  padding: 24px 32px;
  margin-bottom: 1px;
  background: #fff;
  transition: background-color 0.2s;
}

.timeline-item-alt {
  background: #f5f5f5;
}

.timeline-date {
  flex: 0 0 200px;
  font-size: 20px;
  font-weight: 700;
  color: #52c41a;
  margin-right: 40px;
}

.timeline-description {
  flex: 1;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}

/* 移动端 */
@media (max-width: 768px) {
  .banner-section {
    height: 250px;
    margin-bottom: 24px;
  }

  .timeline-section {
    padding: 24px 0;
  }

  .timeline-container {
    padding: 0 16px;
  }

  .timeline-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 16px;
  }

  .timeline-date {
    flex: none;
    width: 100%;
    font-size: 18px;
    margin-right: 0;
    margin-bottom: 12px;
  }

  .timeline-description {
    flex: none;
    width: 100%;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
